var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "f477df0eb9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 157 L 375 157 L 375 218.9375 L 0 218.9375 Z M 0 157 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f477df0eb9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 125.359375 218.410156 C 85.273438 216.90625 19.488281 206.386719 0 167.382812 C 2.519531 167.558594 4.386719 170.519531 6.089844 172.210938 C 10.53125 178.644531 19.296875 179.589844 26.230469 181.972656 C 91.039062 198.65625 157.777344 186.65625 221.507812 171.074219 C 243.980469 165.917969 266.589844 161.023438 289.585938 158.894531 C 304.082031 157.679688 318.988281 155.972656 333.175781 160.140625 C 343.351562 163.554688 353.367188 168.578125 361.851562 175.148438 C 366.695312 180.039062 374.300781 185.488281 375.007812 192.519531 C 372.152344 193.1875 368.917969 189.699219 365.996094 189.625 C 346.996094 184.632812 327.445312 186.039062 308.121094 188.160156 C 246.738281 195.054688 187.644531 218.894531 125.359375 218.410156 Z M 125.359375 218.410156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6d4f7d010099d6b46af468e298394080.svg";
export { ForwardRef as ReactComponent };